var map = {
  "./cs.json": [
    "X2S",
    [
      "hujc"
    ]
  ],
  "./en.json": [
    "UCc",
    [
      "6m3"
    ]
  ],
  "./pl.json": [
    "yTH",
    [
      "sun"
    ]
  ],
  "./ru.json": [
    "aZ",
    [
      "of"
    ]
  ],
  "./tr.json": [
    "ZB6",
    [
      "7e"
    ]
  ],
  "./ja.json": [
    "Uf",
    [
      "yu"
    ]
  ],
  "./zh.json": [
    "yYm",
    [
      "om"
    ]
  ],
  "./pt-br.json": [
    "N4",
    [
      "z9"
    ]
  ],
  "./de.json": [
    "IK",
    [
      "2k"
    ]
  ],
  "./es.json": [
    "K56",
    [
      "4t"
    ]
  ],
  "./fr.json": [
    "IWP",
    [
      "eb"
    ]
  ],
  "./it.json": [
    "n2",
    [
      "d8"
    ]
  ],
  "./ko.json": [
    "d4",
    [
      "zo"
    ]
  ],
  "./pt.json": [
    "fF",
    [
      "hw"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "cL";
module.exports = __rspack_async_context;
